export enum SalesChannel {
    CONSUMER = 'Online.Consumer',
    YOUNG = 'Online.Young',
    FF = 'Online.FamilyFriends'
}
